var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    [
      _c(
        "b-col",
        { staticClass: "pr-0", attrs: { md: "6" } },
        [
          _c(
            "b-form-group",
            {
              staticClass: "mb-1 mr-4",
              attrs: { vertical: "", label: "Точка:" }
            },
            [
              _c("b-form-select", {
                attrs: {
                  value: _vm.filterRestPoint,
                  options: _vm.restPointOptions
                },
                on: { input: _vm.changedRestPoint }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-443fd0b4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-443fd0b4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RestPointFilter.vue
// module id = null
// module chunks = 